import React, { useContext, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import { Alert, Button, Stack, Typography } from '@mui/material'
import API from '../../../services/API'
import { DataGrid } from '@mui/x-data-grid'
import moment from 'moment'
import { EPCRContext } from './EPCR'
import { SiteModeContext } from '../../../components/mainFrame/MainFrame'

const ExistingRecords = ({ setDraftsRecents, draftsRecents }) => {
  const [records, setRecords] = useState([])
  const [fetchError, setFetchError] = useState(false)
  const { setExistingRecord } = useContext(SiteModeContext)
  const { setSiteMode } = useContext(SiteModeContext)

  useEffect(() => {
    API.get(`/epcr-my-${draftsRecents}`).then((res) =>
      res.status === 200 ? setRecords(res.data) : setFetchError(true)
    )
    return () => setDraftsRecents('')
  }, [])

  return (
    <Stack component={Paper} padding={1} gap={1}>
      <Typography variant="title2">My Draft ePCRs</Typography>
      {fetchError && (
        <Alert severity="error">
          Unable to fetch data. Please try again later.
        </Alert>
      )}
      <DataGrid
        columns={[
          {
            field: 'incident.incidentDate',
            headerName: 'Date',
            renderCell: (params) =>
              moment(params.row.incident.incidentDate).format(
                'DD/MM/YYYY HH:mm'
              ),
            flex: 1,
          },
          {
            field: 'ptName',
            headerName: 'Patient',
            renderCell: (params) => {
              const first = params.row?.demographics?.firstName?.[0] ?? ''
              const last = params.row?.demographics?.lastName ?? ''
              const dob = params.row?.demographics?.dob
                ? moment(params.row.demographics.dob).format('(DD/MM/YYYY)')
                : ''
              return `${last} ${first} ${dob}`
            },
            flex: 1,
          },
        ]}
        rows={records}
        disableColumnMenu
        disableColumnSelector
        disableColumnFilter
        hideFooter
        getRowId={(row) => row._id}
        onRowClick={(params) => {
          setSiteMode('ePCR')
          setExistingRecord(params.id)
        }}
      />
    </Stack>
  )
}

export default ExistingRecords
